import { TabbedDatasetPage } from "@/components/Templates/TabbedDatasetPage";

export default function TrialContactList() {
  return (
    <TabbedDatasetPage
      title="Trial Contact List"
      tooltipText="Review trial contacts grouped by their contact category."
      datasetName="trial-contact-list"
      pageFilterKeys={["data_page_name"]}
      constants={{
        wikiLink: "/wiki/guides/exploration-trial-contact-list",
        idLink: undefined,
      }}
    />
  );
}
